import axios from 'axios';
//import * from '@/js/cookie.js'
import { Message} from 'element-ui';
import router from '../router'
/*
 * 根据环境变量区分接口的默认地址
 */
switch(process.env.NODE_ENV){
    case "production":
        axios.defaults.baseURL = "https://api.sneyes.com/api"; // 生产环境地址
        break;
    default:
        axios.defaults.baseURL = "http://farmapi.yh.com/api"; // 默认走开发环境
		 axios.defaults.baseURL = "https://api.sneyes.com/api";
		 break;
}
/*
 * 设置超时时间和跨域是否携带凭证
 */
axios.defaults.timeout = 10000;
axios.defaults.widthCredentials = true;
/*
 * 设置请求传递的数据格式
 */
//axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers['Content-Type'] = 'application/json';
//axios.defaults.transformRequest = data => JSON.stringify(data);
/*
 * 请求拦截器
 * 客户端发送请求 -> [请求拦截器] -> 服务器
 * token校验
 */
axios.interceptors.request.use(config => {
    // 携带上token
  //  let token = cookie.getCookie('token')
	let token=localStorage.getItem("token")
    if(token){
       // config.params = {'token':token} //如果要求携带在参数中
       // config.headers.token= token; //如果要求携带在请求头中
	   config.headers["authorization"] = "Bearer "+token;
    }else{
	//	 cookie.set('token');
	}
    return config;
},error => {
	
    return Promise.reject(error);
});

/*
 * 响应拦截器
 * 服务器信息 -> [拦截的统一处理] -> 客户端js获取到信息
 */
axios.interceptors.response.use(response => {
	//console.log("aaaaaaaaaaaa")
	// console.log(response.data.code)
	if(response.data.code==10050){
			   router.push("/")
			   
			}
     else if(response.data.code==10000){
		
		 return response.data.data;
	 }else{
		 let token=localStorage.getItem("token")
		  if(token){
			  Message({
			          showClose: true,
			          message:response.data.message,
			          type: 'error',
			          duration: 1000
			  })
			   return Promise.reject(error);
		 		
		 }else{
			 Message({
			         showClose: true,
			         message:"你还没有登录",
			         type: 'error',
			         duration: 1000
			 })
			  router.push("/account/login")
		 }
	
		
	 }
   
}, error => {
    let {response} = error;
	
    if(response) {
        // 服务器返回了结果
        switch(response.status) {
            case 401: // 权限问题
                error.message = '未授权，请重新登录'
                break;
            case 403: // token过期
                error.message = '拒绝访问'
                break;
            case 404: // 找不到地址
                error.message = '请求错误,未找到该资源'
                break;
            case 500:
                error.message = '服务器端出错'
        }
		console.log(error.message);
    }else{
        // 服务器没返回结果（服务器崩了、断网了）
		console.log("断网了")
        if(!window.navigator.onLine){
            console.log('断网了...') // 可以自定义回调处理
            return;
        }
        return Promise.reject(error);
    }
});

export default axios;
